var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVacaciones(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CB8252"
    },
    d: "M379.586,105.931c-4.875,0-8.828-3.952-8.828-8.828V52.966c0-19.501-15.809-35.31-35.31-35.31 H176.552c-19.501,0-35.31,15.809-35.31,35.31v44.138c0,4.875-3.952,8.828-8.828,8.828s-8.828-3.952-8.828-8.828V52.966 C123.615,23.726,147.312,0.029,176.552,0h158.897c29.24,0.029,52.936,23.726,52.966,52.966v44.138 C388.414,101.979,384.462,105.931,379.586,105.931z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F5B53"
    },
    d: "M35.31,88.276H476.69c19.501,0,35.31,15.809,35.31,35.31V476.69c0,19.501-15.809,35.31-35.31,35.31 H35.31C15.809,512,0,496.191,0,476.69V123.586C0,104.085,15.809,88.276,35.31,88.276z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#59474E"
    },
    points: "158.897,388.414 158.897,512 105.931,512 105.931,379.586 105.931,167.724 105.931,88.276  158.897,88.276 158.897,158.897  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#59474E"
    },
    points: "353.103,450.207 353.103,512 406.069,512 406.069,370.759 406.069,158.897 406.069,88.276  353.103,88.276 353.103,132.414  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D75E72"
    },
    d: "M189.537,285.59c-2.98,3.245-2.98,8.231,0,11.476c4.047,4.411,5.583,10.573,4.08,16.368 c-1.503,5.795-5.84,10.433-11.522,12.321c-3.053,0.997-5.448,3.391-6.444,6.444c-1.888,5.681-6.526,10.019-12.321,11.522 c-5.795,1.503-11.957-0.033-16.368-4.08c-3.245-2.98-8.231-2.98-11.476,0c-6.733,6.206-17.101,6.206-23.834,0 c-3.245-2.98-8.231-2.98-11.476,0c-4.411,4.047-10.573,5.583-16.368,4.08c-5.795-1.503-10.433-5.84-12.321-11.522 c-0.997-3.053-3.391-5.448-6.444-6.444c-5.681-1.888-10.019-6.526-11.522-12.321c-1.503-5.795,0.033-11.957,4.08-16.368 c2.98-3.245,2.98-8.231,0-11.476c-6.206-6.733-6.206-17.101,0-23.835c2.98-3.245,2.98-8.231,0-11.476 c-4.047-4.411-5.583-10.573-4.08-16.368c1.503-5.795,5.84-10.433,11.522-12.321c3.053-0.997,5.448-3.391,6.444-6.444 c1.893-5.712,6.566-10.067,12.398-11.553c5.832-1.486,12.019,0.1,16.416,4.209c3.173,2.887,8.021,2.887,11.193,0 c6.735-6.318,17.207-6.361,23.993-0.097c3.245,2.98,8.231,2.98,11.476,0c4.411-4.047,10.573-5.583,16.368-4.08 c5.795,1.503,10.433,5.84,12.321,11.522c0.997,3.053,3.391,5.448,6.444,6.444c5.681,1.888,10.019,6.526,11.522,12.321 c1.503,5.795-0.033,11.957-4.08,16.368c-2.98,3.245-2.98,8.231,0,11.476C195.743,268.489,195.743,278.857,189.537,285.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4482C3"
    },
    d: "M374.017,174.197l87.389,87.389c6.895,6.895,6.895,18.073,0,24.968l-43.695,43.695 c-6.895,6.895-18.073,6.895-24.968,0l-87.389-87.389c-6.895-6.895-6.895-18.073,0-24.968l43.695-43.695 C355.944,167.302,367.123,167.302,374.017,174.197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#71C285"
    },
    d: "M311.985,335.263l-30.897-57.097c-1.441-2.769-4.303-4.506-7.424-4.506s-5.983,1.737-7.424,4.506 l-62.102,114.714c-1.532,2.694-1.54,5.994-0.019,8.695c1.52,2.701,4.345,4.406,7.443,4.494h124.186 c3.098-0.088,5.923-1.793,7.443-4.494c1.52-2.701,1.513-6.001-0.019-8.695l-12.023-22.219L311.985,335.263z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0C419"
    },
    d: "M512,158.897c-39.003,0-70.621-31.618-70.621-70.621"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0C419"
    },
    d: "M70.621,512c0-39.003-31.618-70.621-70.621-70.621"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0C419"
    },
    d: "M70.621,88.276c0,39.003-31.618,70.621-70.621,70.621"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0C419"
    },
    d: "M512,441.379c-39.003,0-70.621,31.618-70.621,70.621"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0C419"
    },
    d: "M70.621,512H35.31C15.809,512,0,496.191,0,476.69v-35.31C39.003,441.379,70.621,472.997,70.621,512 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0C419"
    },
    d: "M70.621,88.276c0,39.003-31.618,70.621-70.621,70.621v-35.31c0-19.501,15.809-35.31,35.31-35.31 H70.621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0C419"
    },
    d: "M512,441.379v35.31c0,19.501-15.809,35.31-35.31,35.31h-35.31 C441.379,472.997,472.997,441.379,512,441.379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0C419"
    },
    d: "M512,123.586v35.31c-39.003,0-70.621-31.618-70.621-70.621h35.31 C496.191,88.276,512,104.085,512,123.586z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacaciones);
export default __webpack_public_path__ + "static/media/vacaciones.3ce4a63ef84f8e98f4ece90edd51883f.svg";
export { ForwardRef as ReactComponent };